export const GeofenceData = (data?: any) => {
  return [
    {
      id: 'geoType',
      name: 'geoType',
      type: 'string',
      default: 'circular'
    },
    {
      id: 'geoZoneName',
      name: 'geoZoneName',
      label: 'Geofence Name',
      placeholder: 'Geofence name',
      required: 'Enter geofence name',
      type: 'string',
      min: 4,
      minMessage: 'Minimum 4 charcters is required',
      max: 50,
      maxMessage: 'Maximum 50 characters is required'
    },

    {
      id: 'location',
      name: 'location',
      label: 'Search Location',
      placeholder: 'Search location',
      required: 'Enter location',
      type: data?.geoType === 'polygon' ? 'array' : 'string',
      notRequired: data?.geoType === 'polygon' ? true : false
    },
    {
      id: 'radius',
      name: 'radius',
      label: 'Geofence Radius (KM)',
      placeholder: 'Geofence name',
      required: 'Enter geofence radius (km)',
      type: 'string',
      notRequired: data?.geoType === 'polygon' ? true : false,
      testCases: [
        {
          testCase: function (this: any) {
            const { radius } = this.parent;
            if (radius < 0.01 || radius > 50) {
              return false;
            }
            return true;
          },
          testName: 'radius-error',
          testMessage: 'Enter the radius between 0.01Km to 50Km'
        },
        {
          testCase: function (this: any) {
            const { radius } = this.parent;
            const checkValue = radius && radius?.split('.')[1];
            return radius?.includes('.') && !Boolean(checkValue?.length <= 2)
              ? false
              : true;
          },
          testName: 'check-radius',
          testMessage: 'Enter maximum of 2 digits after decimal point'
        }
      ]
    }
  ];
};

export const GeofenceAssignVehicle = () => {
  return [
    {
      name: 'geofence',
      id: 'geofence',
      placeholder: 'Geofence',
      label: 'Geofence Name',
      type: 'string',
      required: 'Enter geofence name'
    },
    {
      name: 'vehicle',
      id: 'vehicle',
      placeholder: 'Vehicle Number',
      label: 'vehicle Name',
      type: 'array',
      notRequired: true
    }
  ];
};
